import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined';
import { Box } from '@mui/material';
import { AmexIcon } from '~/assets/icons/CreditCard/amex';
import { DinersIcons } from '~/assets/icons/CreditCard/diners';
import { EloIcon } from '~/assets/icons/CreditCard/elo';
import { HiperCardIcon } from '~/assets/icons/CreditCard/hipercard';
import { MastercardIcon } from '~/assets/icons/CreditCard/mastercard';
import { VisaIcon } from '~/assets/icons/CreditCard/visa';
import type { CardBrand } from '~/utils/creditCard';

const ICONS: Partial<Record<CardBrand, () => JSX.Element>> = {
  visa: VisaIcon,
  mastercard: MastercardIcon,
  elo: EloIcon,
  amex: AmexIcon,
  diners: DinersIcons,
  hipercard: HiperCardIcon
};

/** Ícone da bandeira num círculo de 40 px (Figma 2091:3730); bandeira desconhecida usa um cartão genérico. */
export default function CardBrandIcon({ brand }: { brand: CardBrand }) {
  const Icon = ICONS[brand];
  return (
    <Box
      aria-hidden
      sx={{
        alignItems: 'center',
        bgcolor: 'background.paper',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: '100px',
        display: 'flex',
        flexShrink: 0,
        height: 40,
        justifyContent: 'center',
        width: 40
      }}
    >
      {Icon ? <Icon /> : <CreditCardOutlinedIcon sx={{ color: 'text.secondary', fontSize: 22 }} />}
    </Box>
  );
}
